/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Minutes_LessInputs */

const en_confirm_minutes_less = /** @type {(inputs: Confirm_Minutes_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 minutes less`)
};

const he_confirm_minutes_less = /** @type {(inputs: Confirm_Minutes_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 דקות פחות`)
};

/**
* | output |
* | --- |
* | "15 minutes less" |
*
* @param {Confirm_Minutes_LessInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_minutes_less = /** @type {((inputs?: Confirm_Minutes_LessInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Minutes_LessInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_minutes_less(inputs)
	return he_confirm_minutes_less(inputs)
});